"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

var lodash_1 = __importDefault(require("lodash"));

var Auth = __importStar(require("./auth"));

var FirebaseStorage = __importStar(require("./storage"));

var FirebaseGroups = __importStar(require("./groups"));

var firebase_1 = require("../../configs/firebase");

var UtilsRows = __importStar(require("../../utils/row"));

var remote_item_approve_state_1 = __importDefault(require("../../constants/remote-item-approve-state"));

var my_error_1 = __importDefault(require("../../models/my-error"));

var file_info_type_1 = __importDefault(require("../../constants/file-info-type"));

function _build(docSnapshot) {
  var result = Object.assign({}, docSnapshot.data(), {
    id: docSnapshot.id
  });
  return result;
}

function loadApproved(_x, _x2, _x3, _x4) {
  return _loadApproved.apply(this, arguments);
}

function _loadApproved() {
  _loadApproved = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(groupId, filterOpts, userInputs, ownerId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", load({
              groupId: groupId,
              filterOpts: filterOpts,
              userInputs: userInputs,
              approveState: remote_item_approve_state_1.default.APPROVED,
              ownerId: ownerId
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadApproved.apply(this, arguments);
}

exports.loadApproved = loadApproved;

function loadPending(_x5, _x6, _x7, _x8) {
  return _loadPending.apply(this, arguments);
}

function _loadPending() {
  _loadPending = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(groupId, filterOpts, userInputs, ownerId) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", load({
              groupId: groupId,
              filterOpts: filterOpts,
              userInputs: userInputs,
              approveState: remote_item_approve_state_1.default.PENDING,
              ownerId: ownerId
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadPending.apply(this, arguments);
}

exports.loadPending = loadPending;

function loadRejected(_x9, _x10, _x11, _x12) {
  return _loadRejected.apply(this, arguments);
}

function _loadRejected() {
  _loadRejected = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(groupId, filterOpts, userInputs, ownerId) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", load({
              groupId: groupId,
              filterOpts: filterOpts,
              userInputs: userInputs,
              approveState: remote_item_approve_state_1.default.REJECTED,
              ownerId: ownerId
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _loadRejected.apply(this, arguments);
}

exports.loadRejected = loadRejected;

function load(_x13) {
  return _load.apply(this, arguments);
}

function _load() {
  _load = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(opts) {
    var groupId, approveState, ownerId, startAfter, orderBy, query, querySnapshots, docs, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            groupId = opts.groupId, approveState = opts.approveState, ownerId = opts.ownerId, startAfter = opts.startAfter, orderBy = opts.orderBy;
            query = app_1.default.firestore().collection(firebase_1.CN_ITEMS).where('group_id', '==', groupId).where('approve_state', '==', approveState).orderBy('edit_at', orderBy || 'asc').limit(firebase_1.ITEMS_FETCH_LIMIT);

            if (ownerId) {
              query = query.where('owner_id', '==', ownerId);
            }

            if (!!startAfter) {
              query = query.startAfter(new Date(startAfter));
            }

            _context4.next = 6;
            return query.get();

          case 6:
            querySnapshots = _context4.sent;
            docs = querySnapshots.docs;
            result = [];

            if (docs.length > 0) {
              querySnapshots.forEach(function (docSnapShot) {
                result.push(_build(docSnapShot));
              });
            }

            return _context4.abrupt("return", result);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _load.apply(this, arguments);
}

exports.load = load;

function getMyPendingList(_x14) {
  return _getMyPendingList.apply(this, arguments);
}

function _getMyPendingList() {
  _getMyPendingList = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(opts) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", getMyWaitingItems(opts, {
              state: remote_item_approve_state_1.default.PENDING
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getMyPendingList.apply(this, arguments);
}

exports.getMyPendingList = getMyPendingList;

function getMyRejectedList(_x15) {
  return _getMyRejectedList.apply(this, arguments);
}

function _getMyRejectedList() {
  _getMyRejectedList = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(opts) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", getMyWaitingItems(opts, {
              state: remote_item_approve_state_1.default.REJECTED
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getMyRejectedList.apply(this, arguments);
}

exports.getMyRejectedList = getMyRejectedList;

function getMyDetachedList(_x16) {
  return _getMyDetachedList.apply(this, arguments);
}

function _getMyDetachedList() {
  _getMyDetachedList = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(opts) {
    var marker, userId, query, querySnapshots, docs, result, nextMarker;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            marker = opts.marker || null;
            _context7.next = 3;
            return Auth.getUserId();

          case 3:
            userId = _context7.sent;
            query = app_1.default.firestore().collection(firebase_1.CN_ITEMS).where('owner_id', '==', userId).where('group_id', '==', null).orderBy('edit_at', 'desc').limit(firebase_1.WAITING_HANDLE_ITEMS_FETCH_LIMIT);

            if (marker) {
              query = query.startAfter(marker);
            }

            _context7.next = 8;
            return query.get();

          case 8:
            querySnapshots = _context7.sent;
            docs = querySnapshots.docs;
            result = [];
            nextMarker = null;

            if (docs.length > 0) {
              querySnapshots.forEach(function (doc) {
                result.push(_build(doc));
              });
              nextMarker = result[result.length - 1].edit_at;
            }

            return _context7.abrupt("return", {
              list: result,
              marker: nextMarker
            });

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getMyDetachedList.apply(this, arguments);
}

exports.getMyDetachedList = getMyDetachedList;

function getMyWaitingItems(_x17, _x18) {
  return _getMyWaitingItems.apply(this, arguments);
}

function _getMyWaitingItems() {
  _getMyWaitingItems = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(opts, extraOpts) {
    var marker, userId, query, querySnapshots, docs, result, nextMarker;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            marker = opts.marker || null;
            _context8.next = 3;
            return Auth.getUserId();

          case 3:
            userId = _context8.sent;
            query = app_1.default.firestore().collection(firebase_1.CN_ITEMS).where('owner_id', '==', userId).where('approve_state', '==', extraOpts.state).orderBy('edit_at', 'desc').limit(firebase_1.WAITING_HANDLE_ITEMS_FETCH_LIMIT);

            if (marker) {
              query = query.startAfter(marker);
            }

            _context8.next = 8;
            return query.get();

          case 8:
            querySnapshots = _context8.sent;
            docs = querySnapshots.docs;
            result = [];
            nextMarker = null;

            if (docs.length > 0) {
              querySnapshots.forEach(function (doc) {
                result.push(_build(doc));
              });
              nextMarker = result[result.length - 1].edit_at;
            }

            return _context8.abrupt("return", {
              list: result,
              marker: nextMarker
            });

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getMyWaitingItems.apply(this, arguments);
}

function approve(_x19) {
  return _approve.apply(this, arguments);
}

function _approve() {
  _approve = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee9(itemId) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return review(itemId, remote_item_approve_state_1.default.APPROVED);

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _approve.apply(this, arguments);
}

exports.approve = approve;

function reject(_x20) {
  return _reject.apply(this, arguments);
}

function _reject() {
  _reject = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee10(itemId) {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return review(itemId, remote_item_approve_state_1.default.REJECTED);

          case 2:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _reject.apply(this, arguments);
}

exports.reject = reject;

function review(_x21, _x22) {
  return _review.apply(this, arguments);
}

function _review() {
  _review = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee11(itemId, state) {
    var ref;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            ref = app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId);
            return _context11.abrupt("return", app_1.default.firestore().runTransaction(function (t) {
              return t.get(ref).then(function (snap) {
                var data = snap.data();

                if (data) {
                  if (data.approve_state === remote_item_approve_state_1.default.PENDING) {
                    t.update(ref, {
                      approve_state: state
                    });
                  } else {
                    throw new my_error_1.default("Data is not in pending status");
                  }
                } else {
                  throw new my_error_1.default("Data not found ".concat(itemId));
                }
              });
            }));

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _review.apply(this, arguments);
}

exports.review = review;

function getById(_x23) {
  return _getById.apply(this, arguments);
}

function _getById() {
  _getById = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee12(itemId) {
    var docSnapshot;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId).get();

          case 2:
            docSnapshot = _context12.sent;

            if (!docSnapshot.exists) {
              _context12.next = 7;
              break;
            }

            return _context12.abrupt("return", _build(docSnapshot));

          case 7:
            return _context12.abrupt("return", null);

          case 8:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _getById.apply(this, arguments);
}

exports.getById = getById;

function remove(_x24) {
  return _remove.apply(this, arguments);
}

function _remove() {
  _remove = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee13(itemId) {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId).delete();

          case 2:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _remove.apply(this, arguments);
}

exports.remove = remove;

function detach(_x25) {
  return _detach.apply(this, arguments);
}

function _detach() {
  _detach = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee14(itemId) {
    var item, userId;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return getById(itemId);

          case 2:
            item = _context14.sent;
            _context14.next = 5;
            return Auth.getUserId();

          case 5:
            userId = _context14.sent;

            if (!item) {
              _context14.next = 13;
              break;
            }

            if (item.group_id) {
              _context14.next = 9;
              break;
            }

            throw new my_error_1.default("Data is not attached to a database");

          case 9:
            _context14.next = 11;
            return app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId).update({
              group_id: null,
              last_group_id: item.group_id,
              last_detacher_id: userId,
              approve_state: remote_item_approve_state_1.default.NA
            });

          case 11:
            _context14.next = 14;
            break;

          case 13:
            throw new my_error_1.default("Data not found: ".concat(itemId));

          case 14:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _detach.apply(this, arguments);
}

exports.detach = detach;

function resubmit(_x26, _x27) {
  return _resubmit.apply(this, arguments);
}

function _resubmit() {
  _resubmit = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee15(itemId, state) {
    var ref;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            ref = app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId);
            return _context15.abrupt("return", app_1.default.firestore().runTransaction(function (t) {
              return t.get(ref).then(function (snap) {
                if (!snap.exists) {
                  throw new my_error_1.default("Data not found");
                }

                var data = snap.data();

                if (!data) {
                  throw new my_error_1.default("Data compiled failure");
                }

                if (data.approve_state !== remote_item_approve_state_1.default.REJECTED) {
                  throw new my_error_1.default("Data is not rejected state");
                }

                if (data.group_id === null) {
                  throw new my_error_1.default("Data is not attached to database");
                }

                t.update(ref, {
                  approve_state: remote_item_approve_state_1.default.PENDING
                });
              });
            }));

          case 2:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _resubmit.apply(this, arguments);
}

exports.resubmit = resubmit;

function attach(_x28, _x29) {
  return _attach.apply(this, arguments);
}

function _attach() {
  _attach = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee16(groupId, itemId) {
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId).update({
              approve_state: remote_item_approve_state_1.default.PENDING,
              group_id: groupId
            });

          case 2:
            _context16.next = 4;
            return getById(itemId);

          case 4:
            return _context16.abrupt("return", _context16.sent);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _attach.apply(this, arguments);
}

exports.attach = attach;

function attachDirectly(_x30, _x31) {
  return _attachDirectly.apply(this, arguments);
}

function _attachDirectly() {
  _attachDirectly = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee17(groupId, itemId) {
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId).update({
              approve_state: remote_item_approve_state_1.default.APPROVED,
              group_id: groupId
            });

          case 2:
            _context17.next = 4;
            return getById(itemId);

          case 4:
            return _context17.abrupt("return", _context17.sent);

          case 5:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _attachDirectly.apply(this, arguments);
}

exports.attachDirectly = attachDirectly;

function edit(_x32, _x33) {
  return _edit.apply(this, arguments);
}

function _edit() {
  _edit = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee18(itemId, props) {
    var title, subtitle, icon, imgs, rows, can_group_owner_edit, iconFileInfo, imgUris, i, img, updateObj, latest;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            title = props.title, subtitle = props.subtitle, icon = props.icon, imgs = props.imgs, rows = props.rows, can_group_owner_edit = props.can_group_owner_edit;
            iconFileInfo = null;

            if (!icon) {
              _context18.next = 10;
              break;
            }

            if (!(icon.type === file_info_type_1.default.LOCAL)) {
              _context18.next = 9;
              break;
            }

            _context18.next = 6;
            return FirebaseStorage.uploadIconByFileInfoBlob(icon);

          case 6:
            iconFileInfo = _context18.sent;
            _context18.next = 10;
            break;

          case 9:
            if (icon.type === file_info_type_1.default.GC) {
              iconFileInfo = icon;
            }

          case 10:
            imgUris = [];
            i = 0;

          case 12:
            if (!(i < imgs.length)) {
              _context18.next = 26;
              break;
            }

            img = imgs[i];

            if (!(img.type === file_info_type_1.default.LOCAL)) {
              _context18.next = 22;
              break;
            }

            _context18.t0 = imgUris;
            _context18.next = 18;
            return FirebaseStorage.uploadImageByFileInfoBlob(img);

          case 18:
            _context18.t1 = _context18.sent;

            _context18.t0.push.call(_context18.t0, _context18.t1);

            _context18.next = 23;
            break;

          case 22:
            if (img.type === file_info_type_1.default.GC) {
              imgUris.push(img);
            }

          case 23:
            i++;
            _context18.next = 12;
            break;

          case 26:
            updateObj = {
              title: title,
              subtitle: subtitle,
              icon: iconFileInfo,
              imgs: imgUris,
              rows: rows,
              edit_at: app_1.default.firestore.FieldValue.serverTimestamp(),
              can_group_owner_edit: can_group_owner_edit,
              search: _buildSearch(props)
            };

            if (lodash_1.default.has(props, 'cached_owner_nickname')) {
              updateObj['cached_owner_nickname'] = props['cached_owner_nickname'];
            }

            _context18.next = 30;
            return app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId).update(updateObj);

          case 30:
            _context18.next = 32;
            return getById(itemId);

          case 32:
            latest = _context18.sent;

            if (!(latest === null)) {
              _context18.next = 35;
              break;
            }

            throw new my_error_1.default("Failed to fetch the data just edited: ".concat(itemId));

          case 35:
            return _context18.abrupt("return", latest);

          case 36:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _edit.apply(this, arguments);
}

exports.edit = edit;

function addPending(_x34, _x35) {
  return _addPending.apply(this, arguments);
}

function _addPending() {
  _addPending = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee19(groupId, props) {
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", add(groupId, props, {
              approve_state: remote_item_approve_state_1.default.PENDING
            }));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _addPending.apply(this, arguments);
}

exports.addPending = addPending;

function addApproved(_x36, _x37) {
  return _addApproved.apply(this, arguments);
}

function _addApproved() {
  _addApproved = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee20(groupdId, props) {
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            return _context20.abrupt("return", add(groupdId, props, {
              approve_state: remote_item_approve_state_1.default.APPROVED
            }));

          case 1:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _addApproved.apply(this, arguments);
}

exports.addApproved = addApproved;

function add(_x38, _x39, _x40) {
  return _add.apply(this, arguments);
}

function _add() {
  _add = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee21(groupId, props, extraProps) {
    var groupData, userId, title, subtitle, icon, imgs, rows, can_group_owner_edit, cached_owner_nickname, iconFileInfo, imgsFileRef, i, img, servNow, content, docRef, docSnapshot, latest;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return FirebaseGroups.getById(groupId);

          case 2:
            groupData = _context21.sent;

            if (groupData) {
              _context21.next = 5;
              break;
            }

            throw new my_error_1.default("Database not found, it may be deleted.");

          case 5:
            _context21.next = 7;
            return Auth.getUserId();

          case 7:
            userId = _context21.sent;
            title = props.title, subtitle = props.subtitle, icon = props.icon, imgs = props.imgs, rows = props.rows, can_group_owner_edit = props.can_group_owner_edit, cached_owner_nickname = props.cached_owner_nickname;
            iconFileInfo = null;

            if (!icon) {
              _context21.next = 22;
              break;
            }

            if (!(icon.type === file_info_type_1.default.LOCAL)) {
              _context21.next = 21;
              break;
            }

            if (!icon.uri) {
              _context21.next = 18;
              break;
            }

            _context21.next = 15;
            return FirebaseStorage.uploadIconByFileInfoBlob(icon);

          case 15:
            iconFileInfo = _context21.sent;
            _context21.next = 19;
            break;

          case 18:
            throw new Error("FileInfo object is LOCAL type without uri");

          case 19:
            _context21.next = 22;
            break;

          case 21:
            throw new Error("In add procedure, all file info object should be LOCAL type");

          case 22:
            imgsFileRef = [];
            i = 0;

          case 24:
            if (!(i < imgs.length)) {
              _context21.next = 35;
              break;
            }

            img = imgs[i];

            if (!(!!img && img.type === file_info_type_1.default.LOCAL && !!img.uri)) {
              _context21.next = 32;
              break;
            }

            _context21.t0 = imgsFileRef;
            _context21.next = 30;
            return FirebaseStorage.uploadImageByFileInfoBlob(img);

          case 30:
            _context21.t1 = _context21.sent;

            _context21.t0.push.call(_context21.t0, _context21.t1);

          case 32:
            i++;
            _context21.next = 24;
            break;

          case 35:
            servNow = app_1.default.firestore.FieldValue.serverTimestamp();
            content = {
              author_id: userId,
              owner_id: userId,
              group_id: groupId,
              title: title,
              subtitle: subtitle,
              icon: iconFileInfo,
              imgs: imgsFileRef,
              rows: rows,
              can_group_owner_edit: can_group_owner_edit,
              create_at: servNow,
              edit_at: servNow,
              cached_owner_nickname: cached_owner_nickname,
              search: _buildSearch(props)
            };

            if (extraProps) {
              content = Object.assign({}, content, extraProps);
            }

            _context21.next = 40;
            return app_1.default.firestore().collection(firebase_1.CN_ITEMS).add(content);

          case 40:
            docRef = _context21.sent;
            _context21.next = 43;
            return docRef.get();

          case 43:
            docSnapshot = _context21.sent;
            latest = _build(docSnapshot);
            return _context21.abrupt("return", latest);

          case 46:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _add.apply(this, arguments);
}

exports.add = add;

function getListByIds(_x41) {
  return _getListByIds.apply(this, arguments);
}

function _getListByIds() {
  _getListByIds = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee22(ids) {
    var pms, fetchResult, result;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            pms = ids.map(function (id) {
              return getById(id);
            });
            _context22.next = 3;
            return Promise.all(pms);

          case 3:
            fetchResult = _context22.sent;
            result = [];
            lodash_1.default.forEach(fetchResult, function (u) {
              if (u !== null) {
                result.push(u);
              }
            });
            return _context22.abrupt("return", result);

          case 7:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _getListByIds.apply(this, arguments);
}

exports.getListByIds = getListByIds;

function _buildSearch(props) {
  var title = props.title,
      rows = props.rows;
  var result = [title];
  result = lodash_1.default.concat(result, UtilsRows.extractSearchKeys(rows));
  return lodash_1.default.union(result);
}

function getRef(itemId) {
  return app_1.default.firestore().collection(firebase_1.CN_ITEMS).doc(itemId);
}

exports.getRef = getRef;